import React from 'react';
import CariDetailReportFilters from './components/CariDetailReportFilters';
import CariDetailReportTable from './components/CariDetailReportTable';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportCariReportDetailQuery } from '../../../api/endpoints/accountingReport';
import useCariDetailReportData from './hooks/useCariDetailReportData';
import { useLanguage } from '../../../contexts/LanguageContext';

const CariDetailReportPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        loading,
        filters,
        handleApplyFilters,
        handleResetFilters,
        exportParams,
        customerDropdown
    } = useCariDetailReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">
                    {th('cariDetailReport.title') || 'Cari Detay Raporu'}
                </h1>
                <GenericFileExportButton
                    useExportQuery={useLazyExportCariReportDetailQuery}
                    exportParams={exportParams}
                    buttonLabel={th('cariDetailReport.exportExcel') || "Excel'e Aktar"}
                    dataExtractor={(result) => result?.fileBase64}
                    fileNameExtractor={(result) => result?.fileName || 'CariDetayRaporu.xlsx'}
                    contentTypeExtractor={(result) => result?.contentType}
                    exportFormat="base64"
                />
            </div>

            <div className="mb-2">
                <CariDetailReportFilters
                    filters={filters}
                    onApplyFilters={handleApplyFilters}
                    onReset={handleResetFilters}
                    customerDropdown={customerDropdown}
                />
            </div>

            <CariDetailReportTable
                rows={rows}
                loading={loading}
            />
        </div>
    );
};

export default CariDetailReportPage;
